import BookShow from "components/shared/book/show";
import { viewContainer } from "helpers/redux";
import React from "react";
import { config, initialState } from "../formConfig";
import Markup from "./markup";

class ShowFuelCard extends BookShow {
    actionPrint = () => {
        const { modal, config } = this.props;
        return modal({
            name: "print",
            title: "Печать карты",
            CustomBody: Markup,
            bodyData: {
                ...config,
                values: this.state.initial,
            },
        });
    };

    renderBody = () => {
        const { config } = this.props;
        return (
            <Markup
                {...config}
                renderField={this.renderField}
                renderSelect={this.renderSelect}
                renderCheckbox={this.renderCheckbox}
                data={this.state.data}
                Button={this.renderButton}
            />
        );
    };
}

const ConfiguredShow = (props) => <ShowFuelCard {...props} config={config} initialState={initialState} />;

export default viewContainer(ConfiguredShow, "fuel-cards");
